import { createSelector } from 'reselect';
import ConsignmentResponseAnalysisColumns from '../../containers/ConsignmentResponseAnalysisColumns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime = state => state
  .reporting.CONSIGNMENT_RESPONSE_ANALYSIS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.CONSIGNMENT_RESPONSE_ANALYSIS.isLoading;

export const getData =
  ReportDefinitions.CONSIGNMENT_RESPONSE_ANALYSIS.getDataFunction();

export const getColumns =
  createSelector(getData, ConsignmentResponseAnalysisColumns);
